import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {ISidebarItem} from '../interfaces/IsidebarItem';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  constructor(private http: HttpClient) {}

  getSidebarRoutes(): Observable<ISidebarItem[]> {
    return this.http.get<ISidebarItem[]>(
      `assets/instances-config/${environment.currentInstance}/layout/sidebar/sidebar.json`,
    );
  }
}
